import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=6167ec51&scoped=true"
import script from "./PricingDetails.vue?vue&type=script&lang=js"
export * from "./PricingDetails.vue?vue&type=script&lang=js"
import style0 from "./PricingDetails.vue?vue&type=style&index=0&id=6167ec51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167ec51",
  null
  
)

export default component.exports